var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"mx-1",attrs:{"color":"primary","small":""}},on),[_vm._v(" Metric: "+_vm._s(_vm.value)+" ")])]}}])},[_c('span',[_vm._v("Explanation about metrics")])])}
var staticRenderFns = []

export { render, staticRenderFns }